exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fullscreen-main-wrapper[data-v-7ba5bd90] {\n  padding: 0;\n  height: 100%;\n  min-height: 100vh;\n}\n", ""]);

// exports
